export default __webpack_public_path__ + "static/media/project_visual_13.1ec1ffc9.jpg";